import React, { useEffect, useRef, useState } from 'react';
import {
  AnimatedWrapper,
  Collapsible,
  Container,
  Description,
  Wrapper,
} from './EffectChartDropdown.styles';
import { IToggleState, Question } from '../../../../../../../services/reports';
import EffectDropdownTable from '../EffectDropdownTable/EffectDropdownTable';

const ANIMATION_DURATION = 300;

interface EffectChartDropdownProps {
  questions: Question[];
  togglersState: IToggleState;
  description: string;
  isOpen: boolean;
  onExited: () => void;
}

const EffectChartDropdown: React.FC<EffectChartDropdownProps> = ({
  questions,
  togglersState,
  description,
  isOpen,
  onExited,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const onExitedRef = useRef(onExited);
  onExitedRef.current = onExited;

  useEffect(() => {
    if (isOpen) {
      // Expand on the frame after mount so the transition animates from the collapsed state.
      const frame = requestAnimationFrame(() => setIsExpanded(true));
      return () => cancelAnimationFrame(frame);
    }

    setIsExpanded(false);
    const timeout = setTimeout(() => onExitedRef.current(), ANIMATION_DURATION);
    return () => clearTimeout(timeout);
  }, [isOpen]);

  return (
    <AnimatedWrapper isExpanded={isExpanded} aria-hidden={!isExpanded}>
      <Collapsible>
        <Wrapper>
          <Container>
            <Description>{description}</Description>
            <EffectDropdownTable questions={questions} togglersState={togglersState} />
          </Container>
        </Wrapper>
      </Collapsible>
    </AnimatedWrapper>
  );
};

export default EffectChartDropdown;
